import React, { useEffect, useState } from "react";
import Datatable from "core/pagination/datatable";
import { Link } from "react-router-dom";
import { Edit, Eye, PlusCircle, Trash2 } from "react-feather";
import { OverlayTrigger, Tooltip } from "react-bootstrap";
import { useSelector } from "react-redux";
import { loggedInUser } from "core/redux/slice/authSlice";
import LoadingSpinner from "Components/UI/LoadingSpinner";
import Error404 from "MainPages/ErrorPages/error404";
import { useTableSearch } from "core/Operations/useTableSearch";
import TableTop from "Components/UI/TableTop";
import { all_routes } from "Router/all_routes";
import { endOfMonth, format, startOfMonth } from "date-fns";
import dayjs from "dayjs";
import { DatePicker, Switch, Popconfirm } from "antd";
import ReportTools from "Components/UI/ReportTools";
import {
  useDeleteAnnouncementMutation,
  useGetAnnouncementsQuery,
} from "AppQuries/company/announcement";
import AnnouncementDetailModal from "./AnnouncementDetailModal";
import { toast } from "core/Operations/toast";
import Can from "core/Operations/Can";

const { RangePicker } = DatePicker;
const disabled7DaysDate = (current, { from }) => {
  if (from) {
    return Math.abs(current.diff(from, "days")) >= 90;
  }
  return false;
};

const AnnouncementList = () => {
  const userData = useSelector(loggedInUser);

  const [queryParams, setQueryParams] = useState({
    fromDate: format(startOfMonth(new Date(), 1), "yyyy-MM-dd"),
    toDate: format(endOfMonth(new Date(), 1), "yyyy-MM-dd"),
    isTrue: true,
  });
  // const permissions =  useSelector(selectUserPermissions) || [];
  const permissions = userData?.permissions;

  const {
    data,
    isLoading,
    isFetching,
    isError,
    error,
    refetch: getData,
  } = useGetAnnouncementsQuery(
    {
      companyCode: userData?.companyCode,
      locationCode: userData?.locationCode,
      ...queryParams,
    },
    {
      enabled: !!userData.companyCode,
    }
  );

  const announcementData = Array.isArray(data)
    ? data?.map((d, _id) => ({
        sid: _id + 1,
        ...d,
        startDate: d.startDate
          ? format(new Date(d.startDate), "dd-MM-yyyy")
          : "",
        endDate: d.endDate ? format(new Date(d.endDate), "dd-MM-yyyy") : "",
        createDate: d.createDate
          ? format(new Date(d.createDate), "dd-MM-yyyy")
          : "",
        type:
          d.type === "1"
            ? "Employees"
            : d.type === "2"
            ? "Departments"
            : d.type === "3"
            ? "Groups"
            : "",
        // codeDetails: d?.code?.map((p) => p),
      }))
    : [];

  const [isFilterVisible, setIsFilterVisible] = useState(false);

  const toggleFilterVisibility = () => {
    setIsFilterVisible((prevVisibility) => !prevVisibility);
  };

  const { mutate: deleteItem } = useDeleteAnnouncementMutation();

  const columns = [
    {
      title: "S.No",
      dataIndex: "sid",
      sorter: (a, b) => a.sid.length - b.sid.length,
    },
    {
      title: "Title",
      dataIndex: "title",
    },
    {
      title: "Announcement Type",
      dataIndex: "type",
    },
    {
      title: "Start Date",
      dataIndex: "startDate",
    },
    {
      title: "End Date",
      dataIndex: "endDate",
    },
    {
      title: "Created By",
      dataIndex: "createUser",
    },
    {
      title: "Created At",
      dataIndex: "createDate",
    },

    {
      title: "Status",
      dataIndex: "isActive",
      render: (text, record) => (
        <>
          {text === true && (
            <div className="badges badge-linesuccess">Active</div>
          )}
          {text === false && (
            <div className="badges badge-linedanger">In Active</div>
          )}
        </>
      ),
    },

    // hasPermission(
    //   permissions,
    //   "Claims Processing",
    //   "Manage Claims",
    //   "haveEdit"
    // ) &&
    {
      title: "Action",
      className: "action-table-data",
      render: (text, record) => (
        <div className="edit-delete-action">
          <div className="input-block add-lists"></div>
          <Can>
          <OverlayTrigger
            placement="top"
            overlay={<Tooltip id="add-new-tooltip">View</Tooltip>}
          >
            <Link
              className="me-2 p-2"
              // to={${all_routes.audit_log}/${record.auditLogId }`}
              to="#"
              type="button"
              onClick={(e) => {
                e.preventDefault();
                e.stopPropagation();
                viewAnnouncementDetail(record.id);
              }}
            >
              <Eye className="feather-edit" />
            </Link>
          </OverlayTrigger>
          </Can>
          {/* {hasPermission(
            userData?.permissions,
            "Claims Processing",
            "Manage Claims",
            "haveEdit"
          ) && ( */}
          <OverlayTrigger
            placement="top"
            overlay={<Tooltip id="add-new-tooltip">Edit</Tooltip>}
          >
            <Link
              className="me-3"
              to={`${all_routes.edit_announcement}/${record.id}`}
            >
              <Edit className="feather-edit" />
            </Link>
          </OverlayTrigger>
          <OverlayTrigger
            placement="top"
            overlay={<Tooltip id="add-new-tooltip">Delete</Tooltip>}
          >
            <Link className="me-2 p-2" to="#">
              <Popconfirm
                title="Are you sure to Delete?"
                onConfirm={() => deleteItemHandler(record.id)}
              >
                <Trash2 className="feather-delete" />
              </Popconfirm>
            </Link>
          </OverlayTrigger>
          {/* )} */}
          {/* {hasPermission(
                  userData?.permissions,
                  "Claims Processing",
                  "Claim Categories",
                  "haveDelete"
                ) && (
                  <Link className="confirm-text" to="#" onClick={confirmText}>
                    <img src={DeleteIcon} alt="img" />
                  </Link>
                )} */}
        </div>
      ),
    },
  ];
  const searchColumns = columns.map((column) => column.dataIndex);
  const { setSearchValue, filteredData } = useTableSearch(
    announcementData,
    searchColumns
  );

  const updateQueryParams = (key, value) => {
    setQueryParams((prev) => ({ ...prev, [key]: value }));
  };

  const deleteItemHandler = (id) => {
    const payload = {
      companyCode: userData?.companyCode,
      code: id,
    };
    deleteItem(payload, {
      onSuccess: (data) => {
        if (data) {
          toast.success("Announcement Deleted Successfully");
          getData();
        } else {
          toast.warning("Something went wrong");
        }
      },
      onError: (error) => {
        toast.error(error.message || "Something went wrong.");
      },
    });
  };

  const [show, setShow] = useState(false);
  const handleClose = () => setShow(false);
  const [selectedAnnouncement, setSelectedAnnouncement] = useState(null);

  const viewAnnouncementDetail = (id) => {
    const selectedLog = announcementData?.find((log) => log.id === id);
    console.log(selectedLog);
    setSelectedAnnouncement(selectedLog);
    setShow(true);
  };

  if (isLoading || isFetching) return <LoadingSpinner />;
  if (isError) return <Error404 error={error} />;

  return (
    <div>
      <div className="page-wrapper">
        <div className="content">
          <div className="page-header">
            <div className="add-item d-flex">
              <div className="page-title">
                <h4>Announcement</h4>
                <h6>Manage your company announcements</h6>
              </div>
            </div>

            <ReportTools
              columns={columns}
              data={filteredData}
              fileName={`Announcement List ${queryParams.fromDate} - ${queryParams.toDate}`}
              pdfTheme="striped"
              refresh={getData}
            />
            {/* {hasPermission(
              permissions,
              "Claims Processing",
              "Manage Claims",
              "haveAdd"
            ) && ( */}
            <div className="page-btn">
              <OverlayTrigger
                placement="top"
                overlay={
                  <Tooltip id="add-new-tooltip">Add Announcement</Tooltip>
                }
              >
                <Link
                  to={`${all_routes.add_announcement}`}
                  className="btn btn-added"
                >
                  <PlusCircle className="me-2" />
                  Add Announcement
                </Link>
              </OverlayTrigger>
            </div>
            {/* )} */}
          </div>
          <div className="row">
            <div className="col-md-12">
              <div className="card table-list-card border-0">
                <div className="card-body">
                  <TableTop
                    onSearch={setSearchValue}
                    toggleFilterVisibility={toggleFilterVisibility}
                    isFilterVisible={isFilterVisible}
                    showToggle={true}
                  />
                  <div
                    className={`card${isFilterVisible ? " visible" : ""}`}
                    id="filter_inputs"
                    // style={{ display: isFilterVisible ? "block" : "none" }}
                  >
                    
                    <div className="card-body pb-0">
                      <div className="form-row row">
                        <div className="row">
                          <div className="col-lg-2 col-sm-6 col-12 mb-3">
                            <div className="input-blocks">
                              <label className="form-label">&nbsp;</label>
                              <Switch
                                checked={queryParams?.isTrue}
                                checkedChildren="Show Active"
                                unCheckedChildren="Show All"
                                onChange={(checked) =>
                                  updateQueryParams("isTrue", checked)
                                }
                              />
                            </div>
                          </div>
                          <div className="col-lg-3 col-sm-6 col-12 mb-3">
                            <div className="form-group">
                              <label className="form-label">
                                Start Date – End Date
                              </label>
                              <RangePicker
                                // disabledDate={disabled7DaysDate}
                                className="form-control"
                                style={{ display: "flex" }}
                                onChange={(date, dateFormat) => {
                                  updateQueryParams("fromDate", dateFormat[0]);
                                  updateQueryParams("toDate", dateFormat[1]);
                                }}
                                defaultValue={[
                                  dayjs(queryParams.fromDate, "YYYY-MM-DD"),
                                  dayjs(queryParams.toDate, "YYYY-MM-DD"),
                                ]}
                                // format="DD-MM-YYYY"
                              />
                            </div>
                          </div>

                          <div className="col-lg-3 col-sm-6 col-12">
                            <div className="input-blocks">
                              <label className="form-label">&nbsp;</label>
                              <Link
                                className="btn btn-filters ms-auto"
                                onClick={getData}
                                type="button"
                              >
                                <i
                                  data-feather="search"
                                  className="feather-search"
                                />
                                {isFetching ? (
                                  <>
                                    <i className="fas fa-spinner fa-spin me-2"></i>
                                    Loading...
                                  </>
                                ) : (
                                  <>Filter</>
                                )}
                              </Link>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="table-responsive">
                    <Datatable
                      className="table datanew"
                      columns={columns}
                      dataSource={filteredData}
                      rowKey={(record) => record.id}
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <AnnouncementDetailModal
        mode={""}
        show={show}
        handleClose={handleClose}
        data={selectedAnnouncement}
        companyCode={userData?.companyCode}
      />
    </div>
  );
};

export default AnnouncementList;
